<template>
  <section class="cta">
    <div class="cta-inner">
      <div class="cta-left">
        <h3 class="cta-title">有制造或贸易合作需求？</h3>
        <p class="cta-text">无论是产品定制、批量生产，还是进出口对接，欢迎随时联系我们，我们将快速响应。</p>
      </div>
      <div class="cta-actions">
        <a class="btn btn-tel" href="tel:13958349372">☎ 13958349372</a>
        <a class="btn btn-mail" href="mailto:17371988805@163.com">✉ 发送邮件</a>
      </div>
    </div>
  </section>
</template>

<script setup>
// 联系横幅：无逻辑，纯展示
</script>

<style scoped>
.cta {
  background: linear-gradient(120deg, #0a4f97 0%, #0b66bb 55%, #0e7fc9 100%);
  position: relative;
  overflow: hidden;
}

.cta::before,
.cta::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.cta::before {
  width: 320px;
  height: 320px;
  top: -140px;
  right: 8%;
}

.cta::after {
  width: 220px;
  height: 220px;
  bottom: -110px;
  left: 4%;
}

.cta-inner {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 64px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
}

.cta-title {
  font-size: 30px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 12px;
}

.cta-text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  line-height: 1.8;
  max-width: 620px;
}

.cta-actions {
  display: flex;
  gap: 14px;
}

.btn {
  display: inline-flex;
  align-items: center;
  height: 50px;
  padding: 0 30px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 800;
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-tel {
  background: linear-gradient(135deg, #ffc53d, #f5a623);
  color: #17324d;
  box-shadow: 0 10px 26px rgba(245, 166, 35, 0.4);
}

.btn-mail {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
}

.btn:hover {
  transform: translateY(-3px);
}

@media (max-width: 760px) {
  .cta-inner {
    flex-direction: column;
    align-items: flex-start;
    padding: 48px 24px;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-actions {
    flex-direction: column;
    width: 100%;
  }

  .btn {
    justify-content: center;
  }
}
</style>
